import { ValidatorService } from './tools/validator.service';
import { ConstantsService } from './constants.service';
import { AutenticacionService } from './autenticacion.service';
import { ErrorsService } from './tools/errors.service';
import { Http } from '@angular/http';
import { Injectable } from '@angular/core';


@Injectable()
export class CatalogosSatService {
  
  private service_url: string;

  constructor(private http: Http, private constantsService: ConstantsService, private validatorService: ValidatorService,
    private authService: AutenticacionService, private errorService:ErrorsService) {
    this.service_url = this.constantsService.apiURL + '/publicos/catalogos-sat';
  }

  public obtenerFormasPago() {
    const options = this.authService.getAuthHeaders();
    return this.http.get(this.service_url + '/formas-pago', options);
  }
  
  public obtenerUsosCFDI() {
    const options = this.authService.getAuthHeaders();
    return this.http.get(this.service_url + '/usos-cfdi', options);
  }

  public getSatConceptosNotas() {
    return this.http.get(this.service_url + '/conceptos-notas', this.authService.getAuthHeaders());
  }

  public getSatConceptosIngresos() {
    return this.http.get(this.service_url + '/conceptos-ingresos', this.authService.getAuthHeaders());
  }

  public getSatRegimenFiscal() {
    return this.http.get(this.service_url + '/regimen-fiscal', this.authService.getAuthHeaders());
  }
}


// WEBPACK FOOTER //
// ./src/app/services/catalogos-sat-service.ts